import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutThirdFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayoutThirdFull"><Path d="M3 3V7.67L21 7.67V3H3Z" fill="currentColor"/><Path d="M3 14.33V9.67L21 9.67V14.33L3 14.33Z" fill="currentColor"/><Path d="M3 16.33V21H21V16.33L3 16.33Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutThirdFull;
